const n = (s, r) => {
  const t = s.find((e) => e.fieldName === r);
  return t ? (t == null ? void 0 : t.type) === "Enum" ? ["static", "json-logic", "js"] : (t == null ? void 0 : t.type) === "array" ? ["json-logic", "js"] : (t == null ? void 0 : t.type) === "object" ? !t.properties || Object.keys(t.properties).length === 0 ? ["json-logic", "js"] : ["static", "json-logic", "js"] : t.type === "jsOnly" ? ["js"] : ["static", "json-logic", "js"] : ["static"];
};
export {
  n as stepParamsFieldLogicLanguageOptionsResolver
};
